export const breakpoints = {
  mobileSmall: '(max-width: 374px)',
  mobileMedium: '(min-width: 375px)',
  mobileLarge: '(min-width: 576px)',
  tablet: '(min-width: 768px)',
  desktopSmall: '(min-width: 1024px)',
  desktopMedium: '(min-width: 1440px)',
  desktopLarge: '(min-width: 1536px)',
};
